<div class="footer clearfix">
    <img src="assets/layout/images/logo-dark.png" alt="logo" />
    <span class="app-name">toqWEB</span>
    <div class="footer-right">
        <a href="https://github.com/primefaces"><i class="fa fa-github"></i></a>
        <a href="https://www.facebook.com/groups/primefaces"><i class="fa fa-facebook"></i></a>
        <a href="http://twitter.com/primefaces"><i class="fa fa-twitter"></i></a>
        <span>All Rights Reserved - 2017</span>
    </div>
</div>
